import React from 'react'
import "./productlinks.css"

function darazLinks() {

  return (
    <div className='links-container'>
        <div className='each-links'>
            <img src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTpbTdkxkYoB9QeoOkMM1B5Gp6CUO2VS0zsfw&usqp=CAU' alt='' />
            <h3>Fashion</h3>
        </div>
        
        <div className='each-links'>
            <img src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR6p8dGN9C5RMLOdnu3tJCPSTaMQa-SdHBPjA&usqp=CAU' alt='' />
            <h3>Beauty</h3>
        </div>
        
        <div className='each-links'>
            <img src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRF4cVxh3HICCSklb8RndmdtBbRThEfKPaWsw&usqp=CAU' alt='' />
            <h3>Reacharge & Payment</h3>
        </div >
        
        <div className='each-links'>
            <img src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQppVq6DA5wuyT9Ma0TeZEAzygjwzcRjc1ZXw&usqp=CAU' alt='' />
            <h3>Proudly Nepali</h3>
        </div>

        <div className='each-links'>
            <img src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfd2fXvYm6jTJ0WjXqu5zPrUlATRRYxnYOOQ&usqp=CAU' alt='' />
            <h3>Best of Daraz</h3>
        </div>
    </div>
  )
}

export default darazLinks